import { JetpacB2BApi } from 'api'

class ApiOutAccessB2b {
  static generateApiAccessTokenB2b(faberToken: string) {
    return JetpacB2BApi.httpGet(
      `/tenant-access/generate-key`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    ).then((res) => res.data)
  }
  static getTenantAccessInfo(faberToken: string, id?: string) {
    const url = id ? `/tenant-access?tenant_id=${id}` : `/tenant-access`

    return JetpacB2BApi.httpGet(
      url,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    ).then((res) => res.data)
  }

  static addTenantAccess(faberToken: string, body: IApiOutAccessB2b) {
    return JetpacB2BApi.httpPost(
      `/tenant-access`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      body
    )
  }
  static updateTenantAccessData(faberToken: string, body: IApiOutAccessB2b) {
    return JetpacB2BApi.httpPut(
      `/tenant-access`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      body
    )
  }
  static updateApiOutAccessKeyStatus(
    body: IApiOutAccessStatusBackendData,
    faberToken: string
  ) {
    return JetpacB2BApi.httpPatch(
      `tenant-access/status`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      body
    )
  }
}

export default ApiOutAccessB2b

// TODO: What is the endpoint here ?

export interface IApiOutAccessB2b {
  tenant_id: string
  access_type:string
  api_key: string
  api_secret: string
  ips: string | null
  endpoints?: string
  is_active: boolean
  created_by: string
  // These field will be used in put not in post
  tdp_api_master_id?: string
  updated_by?: string
  id?: string
}

export interface IApiOutAccessStatusBackendData {
  id: string
  updated_by: string
  status: boolean
}

// type TenantAPIAccess struct {
//     ID        int64  `json:"tdp_api_master_id" gorm:"primaryKey;column:id"`
//     TenantID  int64  `json:"tenant_id" gorm:"column:tenant_id"`
//     APIKey    string `json:"api_key" gorm:"column:api_key"`
//     APISecret string `json:"api_secret" gorm:"column:api_secret"`
//     IPs       string `json:"ips" gorm:"column:ips"`
//     Endpoints string `json:"endpoints" gorm:"column:endpoints"`
//     IsActive  bool   `json:"is_active" gorm:"column:is_active"`
//     CreatedBy string `json:"created_by" gorm:"column:created_by"`
//     UpdatedBy string `json:"updated_by" gorm:"column:updated_by"`
//     IsDeleted bool   `json:"is_deleted" gorm:"column:is_deleted"`
//     EmailId   string `json:"email_id" gorm:"-"`
// }
